import ChallengeSolveResult from './ChallengeSolveResult';

export default ChallengeSolveResult;
